import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import Card from '../../../Card';

import './style.scss';

export interface SearchAllContentPageHitProps {
  contentType: string;
  link: string;
  title: string | React.ReactElement;
  subtitle?: string | React.ReactElement;
  image?: React.ReactNode;
  hideTag?: boolean;
}

const SearchAllContentPageHit: React.FC<SearchAllContentPageHitProps> = (props) => {
  const {
    contentType,
    link,
    title,
    subtitle,
    image,
    hideTag = false,
  } = props;

  const { t } = useTranslation();

  const classes = c('SearchAllContent__PageHit', `SearchAllContent__PageHit--${contentType}`);

  return (
    <Card className={classes}>
      <Card.Content>
        <Card.Link link={link}>
          <Card.Title title={title} />
        </Card.Link>

        {(!hideTag || link) && (
          <div className="Card__metadata">
            {!hideTag && (
              <Card.Tags
                tags={[{
                  type: 'content_type',
                  name: t(`content_types.${contentType}.type`),
                }]}
              />
            )}

            {link && (
              <span className="Card__metadata__url body--small">
                ...{link}
              </span>
            )}
          </div>
        )}

        <Card.Subtitle
          subtitle={(
            <p className="u-truncate--3">
              {subtitle}
            </p>
          )}
        />
      </Card.Content>

      {image && (
        <Card.Image image={image} />
      )}
    </Card>
  );
};

export default SearchAllContentPageHit;
